module.exports = __webpack_public_path__ + "img/btn_order_down.f493782e.svg";